import React from "react";
import * as Style from "../../styledComponents/PersonalInstruction";
import { Icon } from "antd";
import PhoneNumber from "../../../components/form/components/Countrycode";
import editOutlined from "../../../assets/editOutlined.svg";
import "../Profilepage.css";

const ProfileForm = ({
  formData,
  showPassword,
  setShowPassword,
  handlechange,
  showButtons,
  setShowButtons,
  handleSubmit,
  getProfileDetails,
  setEditIconVisible,
  editIconVisible,
  isTrustee = false,
}) => {
  return (
    <form style={{ width: "35%", marginLeft: "2rem" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <h1 className="MainProfileHeading">Profile Settings</h1>

        {/* Edit Icon should only be visible when editIconVisible is true */}
        {!isTrustee && editOutlined && (
          <>
            {editIconVisible && (
              <img
                src={editOutlined || "/placeholder.svg"}
                alt="Edit"
                onClick={() => {
                  setShowButtons(true);
                  setEditIconVisible(false);
                }}
                className="editImage"
              />
            )}
          </>
        )}
      </div>

      <div style={{ marginTop: "8px" }}>
        <Style.FieldsTitle>Name</Style.FieldsTitle>
        <Style.Input
          disabled={!showButtons || isTrustee}
          style={{ width: "100%" }}
          placeholder="Name"
          type="text"
          value={formData && formData.name}
          onChange={(e) => {
            if (isTrustee) e.preventDefault();
            handlechange(e.target.name, e.target.value);
          }}
          name="name"
        />
      </div>

      {!isTrustee && (
        <div style={{ marginTop: "8px" }}>
          <Style.FieldsTitle>Username</Style.FieldsTitle>
          <Style.Input
            disabled={!showButtons || isTrustee}
            style={{ width: "100%" }}
            placeholder="Username"
            type="text"
            value={formData && formData.userName}
            onChange={(e) => handlechange(e.target.name, e.target.value)}
            name="userName"
          />
        </div>
      )}

      <div style={{ marginTop: "8px" }}>
        <Style.FieldsTitle>Email</Style.FieldsTitle>
        <Style.Input
          disabled={!showButtons || isTrustee}
          style={{ width: "100%" }}
          placeholder="Email"
          type="email"
          value={formData && formData.email}
          onChange={(e) => {
            if (isTrustee) e.preventDefault();
            handlechange(e.target.name, e.target.value);
          }}
          name="email"
        />
      </div>

      <div style={{ marginTop: "8px" }}>
        <Style.FieldsTitle>Phone Number</Style.FieldsTitle>
        {formData && (
          <PhoneNumber
            disabled={!showButtons || isTrustee}
            style={{ width: "100%" }}
            placeholder="Phone Number"
            value={formData.phoneNumber}
            onChange={(e) => handlechange("phoneNumber", e.target.value)}
            name="phoneNumber"
          />
        )}
      </div>

      <div style={{ marginTop: "8px" }}>
        <Style.FieldsTitle>Zip Code</Style.FieldsTitle>
        <Style.Input
          disabled={!showButtons || isTrustee}
          style={{ width: "100%" }}
          placeholder="Zip Code"
          type="text"
          value={formData && formData.zipCode}
          onChange={(e) => {
            if (isTrustee) e.preventDefault();
            handlechange(e.target.name, e.target.value);
          }}
          name="zipCode"
        />
      </div>

      <div style={{ marginTop: "8px" }}>
        <Style.FieldsTitle>Password</Style.FieldsTitle>
        <div
          style={{
            border: "1px solid #ECECEC",
            borderRadius: "5px",
            display: "flex",
          }}
        >
          <Style.Input
            disabled={!showButtons || isTrustee}
            style={{
              width: "100%",
              border: "none",
              paddingInline: "10px",
              paddingBottom: "4px",
            }}
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            value={formData && formData.password}
            onChange={(e) => {
              if (isTrustee) e.preventDefault();
              handlechange(e.target.name, e.target.value);
            }}
            name="password"
          />
          <Icon
            type={showPassword ? "eye-invisible" : "eye"}
            style={{ padding: "12px", fontSize: "18px" }}
            onClick={() => {
              setShowPassword(!showPassword);
            }}
          />
        </div>
      </div>

      {/* Conditionally Render Buttons */}
      {showButtons && !isTrustee && (
        <Style.WrapperButtons>
          <Style.CancelButtonProfile
            onClick={(e) => {
              e.preventDefault();
              getProfileDetails();
              setShowButtons(false);
              setEditIconVisible(true);
            }}
          >
            Discard
          </Style.CancelButtonProfile>

          <Style.SaveButtonProfile
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(e);
              setShowButtons(false);
              setEditIconVisible(true);
            }}
          >
            Save Changes
          </Style.SaveButtonProfile>
        </Style.WrapperButtons>
      )}
    </form>
  );
};

export default ProfileForm;
